import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTaskResourceById } from 'HELPERS/resources';
import { updateResourceData, addResourceData, removeResourceData } from 'ACTIONS/resources.actions';
import './ControlResource.less';

class ControlResource extends Component {
  componentDidMount() {
    if (!window.Echo) {
      // eslint-disable-next-line no-console
      console.error('WebSocket not initialized');

      return;
    }

    const channelId = this.getTaskChannel();
    window.Echo.channel(channelId)
      .listen('TaskCreated', ({ task }) => {
        const resourceName = getTaskResourceById(task.type_id);
        this.props.addResourceData(resourceName, task);
      })
      .listen('TaskDeleted', ({ task }) => {
        const resourceName = getTaskResourceById(task.type_id);
        this.props.removeResourceData(resourceName, task.id);
      })
      .listen('TaskUpdated', ({ task }) => {
        const resourceName = getTaskResourceById(task.type_id);
        this.props.updateResourceData(resourceName, task);
      });
  }

  componentWillUnmount() {
    const channelId = this.getTaskChannel();
    if (window.Echo) {
      window.Echo.leave(channelId);
    }
  }

  getTaskChannel = () => `tasks_${this.props.resourceTypeId}`;

  render() {
    const {
      title, form, children, filterForm, renderBefore, resource, resourceTypeId,
    } = this.props;

    if (!resource || !resourceTypeId) {
      return <div>Loading...</div>;
    }

    return (
      <div className="control-layout">
        {typeof renderBefore === 'function' && <div className="before-content">{renderBefore()}</div>}
        <div className="control-header">
          <div className="header-content">
            <h1 className="title">{title}</h1>
          </div>
          <div className="control-form">{React.cloneElement(form, { resource, resourceTypeId })}</div>
        </div>
        {filterForm && (
          <div className="filter-form">
            {React.cloneElement(filterForm, { resource, resourceTypeId })}
          </div>
        )}
        {children && (
          <div className="control-content">
            {React.cloneElement(children, { resource, resourceTypeId })}
          </div>
        )}
      </div>
    );
  }
}

ControlResource.defaultProps = {
  children: null,
  filterForm: null,
  renderBefore: null,
};

ControlResource.propTypes = {
  title: PropTypes.string.isRequired,
  resource: PropTypes.string.isRequired,
  form: PropTypes.element.isRequired,
  filterForm: PropTypes.element,
  children: PropTypes.element,
  renderBefore: PropTypes.func,
  resourceTypeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  removeResourceData: PropTypes.func.isRequired,
  updateResourceData: PropTypes.func.isRequired,
  addResourceData: PropTypes.func.isRequired,
};

export { ControlResource as PureControlResource };

export default connect(null, {
  updateResourceData,
  addResourceData,
  removeResourceData,
})(ControlResource);



// WEBPACK FOOTER //
// ./src/pages/Control/Resource/ControlResource.js